<template>
  <div :style="note" class="login-wrap" style="" v-show="show">
    <div v-if="!showLogin3">
      <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="right" label-width="0px" 
             class="demo-ruleForm login-container">
             <img src="../common/images/login1.png" alt="" style=" clear: both;display: block;margin:auto; position: absolute; top: -123px;left: 0; right: 0;">
      <h3 class="title">系统登录</h3>
      <el-form-item prop="account">
        <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"
                  @keyup.enter.prevent.native="handleSubmit2"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"
                  @keyup.enter.prevent.native="handleSubmit2"></el-input>
      </el-form-item>
      <el-checkbox v-model="checked" class="remember">记住账号</el-checkbox>
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录
          </el-button>
         <img src="../common/images/login2.png" alt="" style=" clear: both;display: block;margin:auto; position: absolute; top: 198px;left: -105px; right: 0;">
        </el-form-item>
      </el-form>
        <div  class="login-a1" style="text-align:center" onclick="window.open('https://beian.miit.gov.cn')"><h1>普乐师（上海）数字科技股份有限公司 沪ICP备16008893号-4</h1></div>
    </div>
    <Login3 v-else />
  </div>
</template>

<script>
  import utils from '../common/js/util'
  import cook from '../common/js/cook'
  import Login3 from './Login3.vue'
  //  import { requestLogin } from '../api/api';
  //import NProgress from 'nprogress'
  var Url = require("common/images/login3.png")
  export default {
    components:{Login3},
    data() {
      return {
        note: {
          backgroundImage: 'url(' + Url + ')',
          backgroundRepeat: "no-repeat",
          backgroundColor: '#1F2D3D',
          // height: "100vh",
          overflow: 'hidden',
          backgroundSize: '100% 100%',
        },
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            {required: true, message: '请输入账号', trigger: 'blur'},
            //{ validator: validaePass }
          ],
          checkPass: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            //{ validator: validaePass2 }
          ]
        },
        checked: false,
        canNotLogin: 0,//已经由于上个账号未注销而无法登陆的次数
        show: false,
        queryParams: {},
        showLogin3:false
      };
    },
    methods: {
      handleSubmit2(ev) {
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
//this.$router.replace('/table');
            this.logining = true;
            //NProgress.start();
            // var loginParams = {username: this.ruleForm2.account, password: this.ruleForm2.checkPass};
            // console.log(this.ruleForm2.account, this.ruleForm2.checkPass)
            this.$http({
              method: "post",
              url: '/rest/auth/login',
              headers: {'Content-type': 'application/x-authc-username-password+json'},
              data: {
                user: this.ruleForm2.account,
                password: this.ruleForm2.checkPass
              }
            }).then(async res => {
              //因为后台不允许同一个客户端登录两个账号，所以如果登陆了一个账号这里就提示他需要先注销
              //当前请求登录的账号和服务端返回的‘已经登录的账号’名称不匹配时，则判定是第二次登陆
              if (res.data.loginName != this.ruleForm2.account) {
                if (this.canNotLogin <= 1) {
                  this.$alert('您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆，本次登录无效', '提示', {type: 'error'})
                } else {
                  //如果连续2次没进去，则允许强制退出
                  this.$confirm('您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆,  是否强制注销?', '提示', {
                    type: 'warning'
                  }).then(() => {
                    this.$http.post('/rest/auth/logout').then(res => {
                      utils.myNotify(this, 'success', res, '注销成功')//有时候提示该用户未登入，此时code是一串字母，但我们仍然提示注销成功
                      sessionStorage.clear()
                      setTimeout(() => {
                        location.reload(true)
                      }, 1000)
                    }).catch(err => {
                      utils.myNotify(this, 'warning', err.response, '注销失败')
                    })
                  }).catch(() => {})
                }
                this.canNotLogin += 1
              } else {
                //正常情况下直接登录
                this.checked ? localStorage.setItem("user", String(res.data.loginName)) : localStorage.clear();
                //localstorage对应‘记住账号’，sessionstorage不论如何都存，仅在本标签页有效
                sessionStorage.setItem("user", String(res.data.loginName));
                sessionStorage.setItem("passwords", String(this.ruleForm2.checkPass));
                sessionStorage.setItem('nickname', String(res.data.nickname))
                cook.setCookie('user', String(res.data.loginName), 7200);
                //登录成功后获取权限
                this.$http({
                  method: "GET",
                  url: '/rest/sysUser/sysUserLogin',
                  params: {
                    account: this.ruleForm2.account,
                    password: this.ruleForm2.checkPass
                  }
                }).then(res => {
                  //成功后自动跳转到第一个有权限的页面，缺点是顺序被后台控制
                  let webIdArr = []
                  let pathArr = [];
                  let data = res.data
                  let routes = this.$router.options.routes
                  data.webAuthLst.map(item => {
                    webIdArr.push(item.webId)
                  })
                  routes.map(item => {
                    item.children.map(item2 => {
                      if (webIdArr.indexOf(item2.webId) > -1) {
                        pathArr.push(item2.path)
                      }
                    })
                  })
                  //这里其实可以优化，不等map结束，就可以跳转了，但也就几毫秒，无所谓
                  if (pathArr.length > 0) {
                    this.$router.push({path: pathArr[0]});
                  } else {
                    this.$router.push({path: '/noPermission'});
                  }
                    //获取登录人webid44的权限 给qhr页面权限使用
                  data.webAuthLst.forEach((item) => {
                    if (item.webId==44) {
                       sessionStorage.setItem("webId_44Auth",String(item.auth))
                    }
                  })
                  sessionStorage.setItem("account", String(res.data.sysUser.account))
                  sessionStorage.setItem("sysUserId", String(res.data.sysUser.id))
                  sessionStorage.setItem("empPk", String(res.data.sysUser.empPk))
                }).catch((err) => {
                  utils.myNotify(this, 'error', err.response, '获取用户权限信息失败，请稍后重试')
                })
              }

              this.logining = false
            }).catch((err) => {
              utils.myNotify(this, 'error', err.response, '登录失败')
              this.logining = false
            });
          }
        });
      },
      //校验是否是平台传过来的登录路径,无tenantCode传参非平台跳转直接渲染注册页,有tenantCode传参平台跳转
      //平台跳转 有用户名和密码->不渲染注册页面->直接登录  无用户名密码->渲染注册页面->登录成功后回调绑定接口
      checkPlatform() {
        console.log('登录路径',location.href,this.$route.query);
        //  const { tenantCode, account, password } = this.$route.query
         const { tenantCode, userId, token, timeStamp } = this.$route.query
        this.queryParams = JSON.parse(JSON.stringify(this.$route.query))
        // this.$router.replace('/login')
        if (tenantCode === undefined) {
          this.show = true
        } else {
          if (userId !== 'null') {  
            //根据userId, token, timeStamp获取账号密码
          this.$http({
            method: "get",
            url: '/rest/crmAccessFmes/searchByRebuild',
            params: {
              userId: userId,
              token: token,
              timeStamp: timeStamp
            }
          }).then(res => {
            if (res.data.account !== 'null' && res.data.password !== 'null') {  
            this.ruleForm2.account = res.data.data.account
            this.ruleForm2.checkPass = res.data.data.password
            this.handleSubmit2()
          } else {
            this.showLogin3 = true
            this.show = true
          }
          })
          .catch((err) => {
            utils.myNotify(this, 'error', err.response, '查询失败')
          });
          } else {
            this.showLogin3 = true
            this.show = true
          }
        }
      },
      bindAccount() {
        return new Promise(async (resolve, reject) => {
          let res = await this.$http({
            method: "post",
            url: '/rest/crmAccessFmes/saveAccessFmesUser',
            data: {
              account: this.ruleForm2.account,
              password: this.ruleForm2.checkPass,
              tenantCode: this.queryParams.tenantCode
            }
          }).catch((err) => {
            utils.myNotify(this, 'error', err.response, '绑定失败')
          })
          if (res.data.code === '0') {
            resolve(true)
          }
        })
      }
    },
    mounted() {
      document.title = '普乐师CRM'
      this.ruleForm2.account = localStorage.getItem('user') || '';
      this.checkPlatform()
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 314px auto;
    width: 350px;
    position: relative;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }

  body {
    background: #1F2D3D;
  }

  .title {
    text-align: center;
    background: #3DA879;
    font-size: 16px;
    font-family: '微软雅黑';
    color: #fff;
    margin: 40px 40px 20px;
    height: 40px;
    line-height: 40px;
    padding: 0;
    border-radius: 5px;
  }
  .login-a1{
    text-align: center;
    font-size: 16px;
    font-family: '微软雅黑';
    color: #fff;
    margin: 40px 40px 20px;
    height: 40px;
    line-height: 40px;
    padding: 0;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue